"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractControlFlowReplacer = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
let AbstractControlFlowReplacer = class AbstractControlFlowReplacer {
    constructor(controlFlowCustomNodeFactory, identifierNamesGeneratorFactory, randomGenerator, options) {
        this.replacerDataByControlFlowStorageId = new Map();
        this.controlFlowCustomNodeFactory = controlFlowCustomNodeFactory;
        this.identifierNamesGenerator = identifierNamesGeneratorFactory(options);
        this.randomGenerator = randomGenerator;
        this.options = options;
    }
    generateStorageKey(controlFlowStorage) {
        let key = this.randomGenerator.getRandomString(5);
        while (controlFlowStorage.has(key)) {
            key = this.randomGenerator.getRandomString(5);
        }
        return key;
    }
    insertCustomNodeToControlFlowStorage(customNode, controlFlowStorage, replacerId, usingExistingIdentifierChance) {
        const controlFlowStorageId = controlFlowStorage.getStorageId();
        let storageKeysById = this.replacerDataByControlFlowStorageId.get(controlFlowStorageId);
        if (!storageKeysById) {
            storageKeysById = new Map();
            this.replacerDataByControlFlowStorageId.set(controlFlowStorageId, storageKeysById);
        }
        let storageKeysForCurrentId = storageKeysById.get(replacerId);
        if (!storageKeysForCurrentId) {
            storageKeysForCurrentId = [];
            storageKeysById.set(replacerId, storageKeysForCurrentId);
        }
        const shouldPickFromStorageKeysById = this.randomGenerator.getMathRandom() < usingExistingIdentifierChance && storageKeysForCurrentId.length;
        if (shouldPickFromStorageKeysById) {
            return this.randomGenerator.getRandomGenerator().pickone(storageKeysForCurrentId);
        }
        const storageKey = this.generateStorageKey(controlFlowStorage);
        storageKeysForCurrentId.push(storageKey);
        controlFlowStorage.set(storageKey, customNode);
        return storageKey;
    }
};
exports.AbstractControlFlowReplacer = AbstractControlFlowReplacer;
exports.AbstractControlFlowReplacer = AbstractControlFlowReplacer = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IControlFlowCustomNode)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Function, Function, Object, Object])
], AbstractControlFlowReplacer);
